import { AfterViewInit, Component, Input, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ValidationErrors,
  Validators,
} from "@angular/forms";

/**
 * Generated class for the ApprovalInputComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: "approval-input",
  templateUrl: "approval-input.html",
})
export class ApprovalInputComponent implements OnInit, AfterViewInit {
  @Input() group: FormGroup;
  @Input() set config(config: any) {
    this.setConfigData(config);
  }
  @Input() wetSig: boolean = false;

  model: any;

  // Internal data model
  approved: boolean = true;
  id: string;
  componentId: string;
  label: any;
  innerGroup: FormGroup;
  options: string[] = [];
  default: string;
  required: boolean;
  disabled: boolean;
  readonly: boolean = false;
  placeholder: string;
  rows: number = 5;
  minLength: number = 2;
  maxLength: number = 250;
  orderItemId = null;
  reasonRequired: boolean = true;

  constructor(public formBuilder: FormBuilder) {
    // console.log('Hello RadioInputComponent Component');
  }

  ngOnInit(): void {
    //this.group.addControl(this.id, this.formBuilder.control(null));
    this.innerGroup = this.formBuilder.group({});
    this.innerGroup.addControl(
      "approved",
      this.formBuilder.control({ value: true })
    );
  }

  ngAfterViewInit(): void {}

  setConfigData(config) {
    if (config) {
      this.id = config.id;
      this.componentId = config.componentId;
      this.orderItemId = config.orderItemId;
      this.reasonRequired = config.reasonRequired;
      this.label = config.label !== undefined ? config.label : config.id;
      // console.log( "Radio label: ", this.label );
      if (this.label === "false") {
        this.label = false;
      }
      this.readonly = config.readonly;
      if (config.default) {
        this.default = config.default;
      }
      if (config.placeholder) {
        this.placeholder = config.placeholder;
      }
      this.options = config.options;
      this.group.addControl(this.id, this.formBuilder.control(null));

      //set initial val
      this.group.controls[this.id].setValue(this.getCurrentValue());

      this.group.controls[this.id].setErrors(this.getErrors());
      this.group.controls[this.id].setValue(this.getCurrentValue());

      //originally ngAfterInit Code Below
      // Errors can get lost when manually set
      // This is an overzealous approach to guarantee they get maintained
      this.group.valueChanges.subscribe((data) => {
        this.group.controls[this.id].setErrors(this.getErrors());
      });

      this.innerGroup.valueChanges.subscribe((data) => {
        this.group.controls[this.id].setValue(this.getCurrentValue());
        this.group.markAsDirty();

        this.group.controls[this.id].setErrors(this.getErrors());
      });

      console.log(this.innerGroup, this.group);
    }
  }

  getCurrentValue() {
    let value = {
      orderItemId: this.orderItemId,
      approved: this.approved,
      reason: null,
    };
    if (!value.approved && this.innerGroup.contains("reason")) {
      value["reason"] = this.innerGroup.controls["reason"].value;
    }
    return value;
  }

  getErrors(): ValidationErrors {
    let errors = {};
    if (this.innerGroup.contains("reason") && this.reasonRequired) {
      if (
        this.getCurrentValue().reason === null ||
        this.getCurrentValue().reason === "" ||
        this.getCurrentValue().reason === undefined
      ) {
        if (!this.approved) {
          errors["required"] = true;
        }
      }
      if (this.getCurrentValue().reason !== null) {
        if (this.getCurrentValue().reason.length < this.minLength) {
          errors["minlength"] = true;
        }

        if (this.getCurrentValue().reason.length > this.maxLength) {
          errors["maxlength"] = true;
        }
      }
    }
    return Object.keys(errors).length == 0 ? undefined : errors;
  }

  printGroup() {
    console.log(this.innerGroup);
  }

  approvePressed() {
    this.approved = true;
    this.innerGroup.get("approved").setValue(true);
  }

  denyPressed() {
    this.approved = false;
    this.innerGroup.get("approved").setValue(false);
    if (this.reasonRequired) {
      this.innerGroup.addControl(
        "reason",
        new FormControl("", [
          Validators.required,
          Validators.maxLength(this.maxLength),
          Validators.minLength(this.minLength),
        ])
      );
    } else {
      this.innerGroup.addControl(
        "reason",
        new FormControl("", [
          Validators.maxLength(this.maxLength),
          Validators.minLength(this.minLength),
        ])
      );
    }
  }

  public getApproveStyle() {
    if (this.approved) {
      return "rgb(133,191,49)";
    } else {
      return "white";
    }
  }

  public getDenyStyle() {
    if (this.approved) {
      return "white";
    } else {
      return "rgb(208,2,27)";
    }
  }

  public getDenyIconColor() {
    if (this.approved) {
      return "rgb(155,155,155)";
    } else {
      return "white";
    }
  }

  public getApproveIconColor() {
    if (this.approved) {
      return "white";
    } else {
      return "rgb(155,155,155)";
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/configurable/inputs/approval-input/approval-input.ts